module.exports = __webpack_public_path__ + "img/pic-04.93256ccf.png";